<template>
  <div class="maintain_container" :class="tabIndex === 1 ? 'bgc1' : 'bgc2'">
    <div class="top_area" :class="tabIndex === 1 ? 'bt1' : 'bt2'">
      <div class="top_logo">
        <img v-if="tabIndex === 1" src="./images/logo_qj1.png" alt="" />
        <img v-else src="./images/logo_qj2.png" alt="" />
      </div>
    </div>
    <div class="tab_box" :class="tabIndex === 1 ? 'tab_box1' : 'tab_box2'">
      <div class="tab_item" @click="handleTab(1)"></div>
      <div class="tab_item" @click="handleTab(2)"></div>
    </div>
    <div class="top_title">
      <img v-if="tabIndex === 1" src="./images/vip_title1.png" alt="" />
      <img v-else src="./images/vip_title2.png" alt="" />
    </div>
    <div
      class="title_tips"
      :class="tabIndex === 1 ? 'white_color' : 'black_color'"
    >
      兼容OpenClaw等主流平台，东方财富妙想大模型和专业数据库加持，开箱即用
    </div>
    <div class="vip_info white_color" v-if="tabIndex === 1">
      东方财富妙想SkilIs能够实现对金融数据的实时获取、处理，并支持多维度指标的筛选与分析。妙想Skills进阶版，是专为AI投研场景推出的专属套餐，您可通过完成指定任务升级到进阶版，获取更多调用次数。
    </div>
    <div class="vip_info black_color" v-else>
      东方财富妙想SkilIs能够实现对金融数据的实时获取、处理，并支持多维度指标的筛选与分析。妙想Skills旗舰版，是专为AI投研场景推出的专属套餐。
    </div>
    <div class="info_img">
      <img v-if="tabIndex == 1" :src="dailyLimitPic1" alt="" />
      <img v-else :src="dailyLimitPic2" alt="" />
    </div>

    <div class="vip_tips">
      <div :class="tabIndex === 1 ? 'tips_title' : 'tips_title2'">
        使用规则：
      </div>
      <div :class="tabIndex === 1 ? 'tips_text' : 'tips_text2'">
        订阅账号规范:为订阅人专享使用，严禁账号共享。若存在账号共享行为，可能导致订阅权益受限，敬请知悉。
      </div>
      <div :class="tabIndex === 1 ? 'tips_text' : 'tips_text2'">
        严禁滥用APIKey调用:将套餐API
        Key用于允许范围之外的调用将被视为违规或滥用，可能会导致订阅被暂停或APIKey被封禁。
      </div>
    </div>

    <div :class="tabIndex === 1 ? 'limittime_tips' : 'limittime_tips2'">
      为回馈广大用户长期支持，东方财富官方推出限时积分膨胀活动。活动期间，普通版用户每日加赠100次调用次数，进阶版用户和旗舰版用户每日加赠200次调用次数，助力用户获得更充足的资源使用额度。
    </div>

    <div class="bottom_fixed" v-if="tabIndex == 1">
      <div
        class="left_btn"
        tracker-eventcode="djzcdb_000"
        @click="handleAccountBtn"
      >
        <div class="btn_top">{{ accountButtonConfig.btnTitle }}</div>
        <div class="btn_bottom">{{ accountButtonConfig.btnSubTitle }}</div>
        <WxOpenAppItm
          v-if="hasAuth"
          v-on:linkAppMed="linkAppMed"
        ></WxOpenAppItm>
      </div>
      <div
        class="right_btn"
        tracker-eventcode="djkhlx_000"
        @click="handleKhBtn"
      >
        <div class="btn_top">开户立享</div>
        <div class="btn_bottom">开户客户即享免费3个月</div>
        <WxOpenAppItm
          v-if="hasAuth"
          v-on:linkAppMed="linkAppMed"
        ></WxOpenAppItm>
      </div>
    </div>

    <div class="bottom_fixed2" v-else @click="handleUpdateBtn">
      <div class="update_btn">
        <img src="./images/btn_sj.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import fetchData from "@/utils/fetchData"; 
import { getActConfigInfo } from "@/utils/common";
import { useMainStore } from "@/pinia/main";
import { storeToRefs } from "pinia";
import { appInfo, pageEnv } from "@eastmoney/mku";
const { hasAuth } = storeToRefs(useMainStore());
const route = useRoute();
const WxOpenAppItm = defineAsyncComponent(() =>
  import("@/components/WxOpenAppItm.vue").then(
    (module: any) => module.default || module
  )
);
const dailyLimitPic1 = ref("");
const dailyLimitPic2 = ref("");
const tabIndex = ref(1);
const upgradeNow = ref<string[]>([])
const accountButtonConfig = ref({
  btnTitle: "账户等级达标",
  btnSubTitle: "等级达标V2每月免费领",
  btnAdrLink:
    "dfcft://emrn?id=AccountAssetLevel&page=Home&fromPage=mxskills",
  btniOSLink:
    "eastmoney://page/emrn?id=AccountAssetLevel&page=Home&fromPage=mxskills",
  btnOhLink:
    "emoh://emrn?id=AccountAssetLevel&page=Home&fromPage=mxskills",
});

watch(
  () => route.query.source,
  (source) => {
    tabIndex.value = source === "qjb" ? 2 : 1;
  },
  { immediate: true }
);

onMounted(() => {
  window.pageLoadMed();
  getAccountButtonConfig();
  getActConfigInfo((configData: any) => {
    console.log(configData, "----configData");
    dailyLimitPic1.value = configData.dailyLimitPic;
    dailyLimitPic2.value = configData.dailyLimitPic2;
    upgradeNow.value =  configData.upgradeNow;
  });
});

const getAccountButtonConfig = () => {
  fetchData
    .doGet({
      api: "https://mkapi.dfcfs.com/actExternalUtilService/api/config/activity/multi-table/mk_000891",
      success: (res: any) => {
        const config =
          res?.status === 0
            ? res?.data?.tables?.accountassetlevel?.[0]
            : null;
        if (!config) {
          return;
        }
        accountButtonConfig.value = {
          ...accountButtonConfig.value,
          ...config,
        };
      },
    })
    .catch(() => {});
};

const handleTab = (tab: number) => {
  tabIndex.value = tab;
};
//立即升级
const handleUpdateBtn = () => {
  if (appInfo.isIOS) {
    window.location.href = upgradeNow.value[0] || `eastmoney://page/emrn?id=llmChatRn&redirect=Skills`;
  } else {
    window.location.href = upgradeNow.value[1] || `dfcft://emrn?id=llmChatRn&redirect=Skills`;
  }
};
//账户等级达标
const handleAccountBtn = () => {
  appInfo.inApp(
    () => {
      const targetLink = appInfo.isOpenHarmony
        ? accountButtonConfig.value.btnOhLink
        : appInfo.isIOS
          ? accountButtonConfig.value.btniOSLink
          : accountButtonConfig.value.btnAdrLink;

      if (targetLink) {
        window.location.href = targetLink;
      }
    },
    () => {
      window.linkAppMed();
    }
  );
};
//开户立享
const handleKhBtn = () => {
  appInfo.inApp(
    () => {
      if (pageEnv != "prod") {
        if (appInfo.isIOS) {
          window.location.href = `eastmoney://wireless/h5/nonavweb?titlebartype=0&emthemetype=&emthemenavmode=1&url=http%3A%2F%2Fceshi.securities.eastmoney.com%3A7466%2Factivity%2Fzqhdweb%2FuserCenter%2Findex.html%23%2FopenAccountHome`;
        } else {
          window.location.href = `dfcft://webh5?titlebartype=trans&emthemetype=&url=http%3A%2F%2Fceshi.securities.eastmoney.com%3A7466%2Factivity%2Fzqhdweb%2FuserCenter%2Findex.html%23%2FopenAccountHome`;
        }
      } else {
        if (appInfo.isIOS) {
          window.location.href = `eastmoney://wireless/h5/nonavweb?titlebartype=0&emthemetype=&emthemenavmode=1&url=https%3A%2F%2Fzqhdplus.eastmoney.com%2Factivity%2Fzqhdweb%2FuserCenter%2Findex.html%23%2FopenAccountHome`;
        } else {
          window.location.href = `dfcft://webh5?titlebartype=trans&emthemetype=&url=https%3A%2F%2Fzqhdplus.eastmoney.com%2Factivity%2Fzqhdweb%2FuserCenter%2Findex.html%23%2FopenAccountHome`;
        }
      }
    },
    () => {
      window.linkAppMed();
    }
  );
};

const linkAppMed = () => {
  window.linkAppMed();
};
</script>

<style scoped lang="scss">
.maintain_container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding-bottom: 2rem;
  &.bgc1 {
    background: url("./images/vip_top1.png") no-repeat;
    background-size: 7.5rem 3.2rem;
    background-color: #fff;
  }
  &.bgc2 {
    background: url("./images/vip_top2.png") no-repeat 0 0 / 7.5rem 3.2rem,
      linear-gradient(0deg, #36291e 0%, #090b01 100%) no-repeat 0 3.1rem / 100%
        calc(100% - 3.1rem);
  }
  .top_area {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 7.5rem;
    height: 0.96rem;
    margin: 0 auto;
    border-bottom: 0.02rem solid rgba(255, 255, 255, 0.1);
    &.bt1 {
      border-bottom: 0.02rem solid rgba(0, 0, 0, 0.1);
    }
    &.bt2 {
      border-bottom: 0.02rem solid rgba(255, 255, 255, 0.1);
    }
    .top_logo {
      width: 5.34rem;
      height: 0.44rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .tab_box {
    margin-top: 0.3rem;
    width: 3.68rem;
    height: 0.72rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    &.tab_box1 {
      background-image: url("./images/tab_box1.png");
    }
    &.tab_box2 {
      background-image: url("./images/tab_box2.png");
    }
    .tab_item {
      width: 50%;
      height: 100%;
      font-size: 0;
    }
  }
  .top_title {
    margin-top: 0.26rem;
    width: 4.73rem;
    height: 0.61rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title_tips {
    margin-top: 0.24rem;
    text-align: center;
    width: 6.86rem;
    align-items: center;
    font-size: 0.28rem;
    color: #333333;
  }
  .white_color {
    color: #333333 !important;
  }
  .black_color {
    color: #fff3df !important;
  }
  .vip_info {
    margin-top: 0.24rem;
    width: 6.86rem;
    font-size: 0.28rem;
    color: #333333;
    text-align: justify;
    line-height: 0.44rem;
  }
  .info_img {
    margin-top: 0.32rem;
    width: 6.9rem;
    height: auto;
    font-size: 0;
    img {
      width: 100%;
      height: auto;
    }
  }
  .vip_tips {
    margin-top: 0.32rem;
    width: 6.86rem;
    .tips_title {
      font-size: 0.28rem;
      color: #333333;
      font-weight: bold;
    }
    .tips_title2 {
      font-size: 0.28rem;
      color: #fff3df;
      font-weight: bold;
    }
    .tips_text {
      margin-top: 0.16rem;
      font-size: 0.24rem;
      color: #666666;
    }
     .tips_text2 {
      margin-top: 0.16rem;
      font-size: 0.24rem;
      color: rgba(255,243,223,0.70);
    }
  }
  .limittime_tips {
    margin-top: 0.32rem;
    box-sizing: border-box;
    padding: 0.24rem;
    width: 6.86rem;
    height: auto;
    background: #fff7ed;
    border: 0.01rem solid #f7e9d2;
    border-radius: 0.24rem;
    line-height: 0.44rem;
    color: #333333;
  }
  .limittime_tips2 {
    margin-top: 0.32rem;
    box-sizing: border-box;
    padding: 0.24rem;
    width: 6.86rem;
    height: auto;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 0.24rem;
    line-height: 0.44rem;
    color: rgba(255, 243, 223, 0.7);
  }

  .bottom_fixed {
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    padding-top: 0.2rem;
    width: 100%;
    height: 1.5rem;
    background: #ffffff;
    box-shadow: 0 0 0.16rem 0 rgba(0, 0, 0, 0.08);

    .left_btn {
      position: relative;
      width: 3.36rem;
      height: 1rem;
      border-radius: 0.5rem;
      background: rgba(255, 85, 0, 0.1);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .btn_top {
        font-size: 0.32rem;
        color: #ff5500;
        line-height: 0.44rem;
        font-weight: bold;
      }
      .btn_bottom {
        font-size: 0.24rem;
        color: #ff5500;
      }
    }
    .right_btn {
      position: relative;
      margin-left: 0.16rem;
      width: 3.36rem;
      height: 1rem;
      border-radius: 0.5rem;
      background: #ff5500;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .btn_top {
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.44rem;
        font-weight: bold;
      }
      .btn_bottom {
        font-size: 0.24rem;
        color: #ffffff;
      }
    }
  }

  .bottom_fixed2 {
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    padding-top: 0.2rem;
    width: 100%;
    height: 1.5rem;
    background: #36291e;
    box-shadow: 0 0 0.16rem 0 rgba(0, 0, 0, 0);
    .update_btn {
      width: 6.86rem;
      height: 1rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
